module.exports = __webpack_public_path__ + "static/media/assembly1.1a60f293.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/gameRocketRepair/assembly1.png
// module id = 2419
// module chunks = 0